// Create an Intersection Observer object
const options = {
  root: null, // viewport
  rootMargin: "0px", // margin around the viewport
  threshold: 0.5, // percentage of the target element that needs to be visible
};

const observer = new IntersectionObserver(callback, options);
let observedProductCards = [];

// Define the callback function
function callback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // Element is in the viewport
      const productItem = entry.target;

      // Extract data from the grid__item product__item element (customize this part)
      const productId = productItem.getAttribute("data-product-id");
      const productName = productItem.getAttribute("data-product-name");
      const productPrice = productItem.getAttribute("data-product-price");
      const productVendor = productItem.getAttribute("data-product-vendor");
      const productVariant = productItem.getAttribute("data-product-variant");
      const productCollection = productItem.getAttribute(
        "data-product-collection"
      );
      const CollectionId = productItem.getAttribute("data-collection-id");
      const indexNumber = productItem.getAttribute("product-index-number");

      observedProductCards.push({
        item_id: productId,
        item_name: productName,
        index: indexNumber,
        item_brand: productVendor,
        item_list_id: CollectionId,
        item_list_name: productCollection,
        item_variant: productVariant,
        price: productPrice,
        quantity: 1,
      });

      if (observedProductCards.length >= 4) {
        // Push the data into the dataLayer for a group of 4 product cards
        // window.dataLayer = window.dataLayer || [];
        // window.dataLayer.push({
        //   event: "view_item_list",
        //   ecommerce: {
        //     items: observedProductCards,
        //   },
        // });
        gtag("event", "view_item_list", {
          send_to: "G-M5EZN8PJCH",
          item_list_id: CollectionId,
          item_list_name: productCollection,
          items: observedProductCards,
        });

        // Clear the observed product cards array
        observedProductCards = [];
      }

      // Unobserve the target element
      // observer.unobserve(productItem);
    }
  });
}

// Observe all elements with the class [grid__item product__item]
const productItems = document.querySelectorAll(".grid__item.product__item");
productItems.forEach((productItem) => {
  observer.observe(productItem);
});

// GA Events Code Push on Click Product Cards Collection Page
document.addEventListener("DOMContentLoaded", function () {
  let collectionItems = document.querySelectorAll(".merca_plp_click");

  const handleClick = function () {
    const productName = this.getAttribute("data-product-name");
    const productId = this.getAttribute("data-product-id");
    const productVendor = this.getAttribute("data-product-vendor");
    const productVariant = this.getAttribute("data-product-variant");
    const productPrice = this.getAttribute("data-product-price");
    const productCollection = this.getAttribute("data-product-collection");
    const CollectionId = this.getAttribute("data-collection-id");
    const indexNumber = this.getAttribute("product-index-number");
    gtag("event", "select_item", {
      send_to: "G-M5EZN8PJCH",
      item_list_id: CollectionId ? CollectionId : "home",
      item_list_name: productCollection ? productCollection : "home",
      items: [
        {
          item_id: productId,
          item_name: productName,
          index: indexNumber,
          item_brand: productVendor,
          item_list_id: CollectionId ? CollectionId : "home",
          item_list_name: productCollection ? productCollection : "home",
          item_variant: productVariant,
          price: productPrice,
          quantity: 1,
        },
      ],
    });
    // dataLayer.push({
    //   event: "select_item",
    //   ecommerce: {
    //     items: [
    //       {
    //         item_id: productId,
    //         item_name: productName,
    //         index: indexNumber,
    //         item_brand: productVendor,
    //         item_list_id: CollectionId,
    //         item_list_name: productCollection,
    //         item_variant: productVariant,
    //         price: productPrice,
    //         quantity: 1,
    //       },
    //     ],
    //   },
    // });
  };

  const attachEventListeners = () => {
    console.log("focus");
    Array.from(collectionItems).forEach(function (element) {
      element.addEventListener("click", handleClick);
    });
  };

  const removeEventListeners = () => {
    Array.from(collectionItems).forEach(function (element) {
      element.removeEventListener("click", handleClick);
    });
  };

  attachEventListeners();
});
